import React from "react";
export default function Flex(props) {
  return (
    <div
      className={props.className}
      style={{
        display: "flex",
        flexDirection: props.column ? "column" : "row",
        alignItems: props.alignItems || "center",
        justifyContent: props.between ? "space-between" : "start",
      }}
    >
      {props.children}
    </div>
  );
}
